import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {WorkbookModel} from "../../../../_stores/workbooks/_models/workbooks.model";
import {GradeModel} from "../../../../_stores/grades/_models/grades.model";
import {Store} from "@ngxs/store";
import {Router} from "@angular/router";
import {RouterSelectors} from "../../../../_stores/router/router.selectors";
import {isPlatformBrowser} from "@angular/common";
import {GradesState} from "../../../../_stores/grades/_state/grades.state";
import {WorkbooksState} from "../../../../_stores/workbooks/_state/workbooks.state";
import {ModalOpenAction} from "../../../../_stores/modal/_actions/modal.actions";

@Component({
  selector: 'bh-page-store',
  templateUrl: './bh-page-store.component.html',
  styleUrls: ['./bh-page-store.component.scss']
})
export class BhPageStoreComponent implements OnInit, OnDestroy{
  interface: {
    submit: boolean,
    workbooks: WorkbookModel[],
    grades: GradeModel[],
    grade: GradeModel,
    series: any[],
    serie: string,
    search_query: {
      date: Date,
      inner: string,
      normalise: string,
      result: any[],
      empty : boolean
    }
    platform: any,
    _cache: any
  } = {
    submit: false,
    workbooks: [],
    grades: [],
    grade: null,
    series: [],
    serie: null,
    search_query: {
      date: undefined,
      inner: undefined,
      normalise: undefined,
      result: [],
      empty: false
    },
    platform: undefined,
    _cache: {
      workbooks:[],
      hero_workbooks:[],
      open_select_series: false,
      open_select_grade: false,
      subscribe: {
        router: undefined
      }
    }
  }
  constructor(private store: Store, private router: Router,private cdr: ChangeDetectorRef, @Inject(PLATFORM_ID) platformId: Object) {
    this.interface.platform = platformId;
  }

  ngOnInit(): void {
    this.initRouteParams();
    this.initGrades();
    this.initBookSeries();
    this.initWorkbooks();
  }
  ngOnDestroy(): void {
    if (!this.interface._cache) {return}
    Object.keys(this.interface._cache.subscribe).forEach((_subscribe) => {
      if (this.interface._cache.subscribe[_subscribe]) {
        this.interface._cache.subscribe[_subscribe].unsubscribe();
      }
    });
  }

  initRouteParams(): void {
    this.interface._cache.subscribe.router = this.store.select(RouterSelectors.data).subscribe((_data) => {
      if(_data.private) {
        if(isPlatformBrowser(this.interface.platform)) {
          this.router.navigate(['/']).then();
        }
      }
    });
  }
  initGrades(): void {
    this.interface._cache.subscribe.grades = this.store.select(GradesState.selectGrades).subscribe((_grades: GradeModel[])=> {
      if(!_grades) { return;}
      if (this.interface.grades.length > 0) {return;}
      this.interface.grades = _grades;

      this.cdr.detectChanges();
    });
  }
  initBookSeries(): void {
    this.interface._cache.subscribe.series = this.store.select(WorkbooksState.selectWorkbooksSeries).subscribe((_series: any[])=> {
      if(!_series) { return;}
      if (this.interface.series.length > 0) {return;}
      this.interface.series = _series;
      this.cdr.detectChanges();
    });
  }
  initWorkbooks(): void {
    this.interface._cache.subscribe.workbooks = this.store.select(WorkbooksState.selectStoreWorkbooks).subscribe((_workbooks: WorkbookModel[])=> {
      if(!_workbooks) { return;}
      if (this.interface._cache.workbooks.length > 0) {return;}
      this.interface._cache.workbooks = _workbooks;
      this.interface._cache.hero_workbooks = this.createWorkbooksGroups(_workbooks, 3, 8);
      this.initHeroWorkbooksList();
      this.cdr.detectChanges();
    });
  }
  initHeroWorkbooksList() : void {
    this.interface.workbooks = this.interface._cache.workbooks;
    if (this.interface.search_query.normalise && this.interface.search_query.normalise.length > 0) {
      this.interface.workbooks = this.interface.workbooks.filter((item) => {
        return item.description.toLowerCase().includes(this.interface.search_query.normalise.toLowerCase());
      });
      this.interface._cache.hero_workbooks = this.createWorkbooksGroups(this.interface.workbooks, 8, 1);
    }
    else {
      this.interface._cache.hero_workbooks = this.createWorkbooksGroups(this.interface.workbooks, 3, 8);
    }
  }


  actionSelectSearchString(search_string: string): void {
    this.interface.search_query.normalise = ''+search_string.replace(/[^a-zA-Z0-9\- ]/g, '');
    this.initHeroWorkbooksList();
  }
  actionEnterSearchString(event): void {
    this.interface.search_query.normalise = ''+event.target.value.replace(/[^a-zA-Z0-9\- ]/g, '');
    this.initHeroWorkbooksList();
  }
  actionPasteSearchString(event): boolean {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData?.getData('text');
    if(pastedText) {
      this.interface.search_query.normalise = ''+pastedText.replace(/[^a-zA-Z0-9\- ]/g, '');
      this.initHeroWorkbooksList();
    }
    return false;
  }
  actionGrantSearchString(only_check?: boolean): boolean {
    let _grant = true;
    this.initHeroWorkbooksList();
    return _grant;
  }
  actionClearSearchString(): void {
    this.interface.search_query.normalise = undefined;
    this.initHeroWorkbooksList();
  }

  createWorkbooksGroups(arr, groupSize, groupCount) {
    const shuffled = [...arr].sort(() => 0.5 - Math.random()); // Копируем и перемешиваем массив
    const groups = [];

    for (let i = 0; i < groupCount; i++) {
      const group = shuffled.slice(i * groupSize, i * groupSize + groupSize);
      groups.push(group);
    }

    return groups;
  }

}
